import EditIcon from "@mui/icons-material/Edit";
import { Container, IconButton, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import { extractUpdatedFields, isEmptyObject } from "nhb-toolbox";
import { useState } from "react";
import { useNavigate } from "react-router";
import { getFormattedCurrency } from "src/Helpers/utils";
import { toast } from "src/Toaster/Toaster";
import type { IStallDetails } from "src/Types/module/fairStall/fairStallType";
import { getStatusLabel } from "src/Utils/Combined";
import DetailsDataShowByGrid from "src/common/DetailsDataShowByGrid";
import { useApiMutation } from "src/hooks/useApiMutation";

interface Props {
	stallDetails: IStallDetails;
}

function SingleStallInfo({ stallDetails }: Props) {
	const navigate = useNavigate();

	const [showModal, setShowModal] = useState<boolean>(false);

	const { mutate: updateStall, isPending } = useApiMutation<
		Record<string, any>,
		void
	>({
		method: "PATCH",
		endPoint: `/api/fair/stall/${stallDetails.fair_stall_id}`,
		invalidateQueries: [
			"FairStalls",
			"SingleStall",
			String(stallDetails.fair_stall_id),
		],
	});

	const handleUpdateStall = (data: Record<string, any>) => {
		const updated = extractUpdatedFields(stallDetails, data);

		if (isEmptyObject(updated)) {
			return toast.fire({
				icon: "warning",
				title: "Nothing to update!",
				position: "top",
			});
		}

		updateStall(updated);
	};

	return (
		<>
			<Container sx={{ pt: 2, mb: 5 }}>
				{/* <Box
					sx={{
						display: "flex",
						justifyContent: "end",
						alignItems: "center",
					}}
				>
					<Box textAlign="end">
						<Tooltip title="Edit">
							<IconButton
								onClick={() => setShowModal(true)}
								sx={{ cursor: "pointer" }}
							>
								<EditIcon />
							</IconButton>
						</Tooltip>
					</Box>
				</Box> */}

				<Box sx={{ mb: 3 }}>
					<Typography
						textAlign='center'
						gutterBottom
						variant='h2'
						component='div'
					>
						{stallDetails?.stall_no}
					</Typography>
					<Typography
						textAlign='center'
						variant='body2'
						color='text.secondary'
					>
						{getStatusLabel(
							stallDetails?.fair_stall_available_status
						)}
					</Typography>
				</Box>
				<DetailsDataShowByGrid
					fields={[
						{
							label: "Stall No.",
							value: stallDetails?.stall_no,
						},
						{
							label: "Stall Type",
							value: stallDetails?.fair_stall_type,
						},
						{
							label: "Hall Name",
							value: stallDetails?.fair_stall_hall_name,
						},
						{
							label: "Stall Price",
							value: getFormattedCurrency(
								stallDetails?.fair_stall_price
							),
						},
						{
							label: "Early Bird Price",
							value: getFormattedCurrency(
								Number(stallDetails?.early_bird_price)
							),
						},
						{
							label: "Super Early Bird Price",
							value: getFormattedCurrency(
								Number(stallDetails?.super_early_bird_price)
							),
						},
						{
							label: "Toab Member Price",
							value: getFormattedCurrency(
								Number(stallDetails?.toab_member_price)
							),
						},
						{
							label: "Creation Date",
							value: moment(
								stallDetails?.fair_stall_created_at
							).format("LL"),
						},

						{
							label: "Service Item Name",
							value: stallDetails?.payment_item_name,
						},
						{
							label: "Air Conditioned",
							value: stallDetails?.fair_stall_air_conditioned
								? "Yes"
								: "No",
						},
						{
							label: "Booked Company Name",
							value: stallDetails?.booked_by_company_name,
						},
					]}
				/>
			</Container>

			{/* <ModalsWrapper
				showModal={showModal}
				setShowModal={setShowModal}
				modalData={{
					title: `Update Stall: ${stallDetails.fair_stall_name}`,
				}}
			>
				<StallForm
					isPending={isPending}
					onSubmit={(data) => {
						handleUpdateStall(data);
						setShowModal(false);
					}}
					buttonText='Update Stall'
					defaultValues={stallDetails}
				/>
			</ModalsWrapper> */}
		</>
	);
}

export default SingleStallInfo;
